import { render, staticRenderFns } from "./changeWord-login.vue?vue&type=template&id=bd1dc24c&scoped=true"
import script from "./changeWord-login.vue?vue&type=script&lang=js"
export * from "./changeWord-login.vue?vue&type=script&lang=js"
import style0 from "./changeWord-login.vue?vue&type=style&index=0&id=bd1dc24c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1dc24c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd1dc24c')) {
      api.createRecord('bd1dc24c', component.options)
    } else {
      api.reload('bd1dc24c', component.options)
    }
    module.hot.accept("./changeWord-login.vue?vue&type=template&id=bd1dc24c&scoped=true", function () {
      api.rerender('bd1dc24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginreg/changeWord-login.vue"
export default component.exports